/** Build NWS MapClick URL from property-location.json fields. */
export function buildNwsMapClickUrl(opts: {
  mapClickCity: string;
  state: string;
  office: string;
  latitude: number;
  longitude: number;
}): string {
  const lat = opts.latitude.toFixed(4);
  const lon = opts.longitude.toFixed(4);
  const city = encodeURIComponent(opts.mapClickCity);
  return `https://forecast.weather.gov/MapClick.php?CityName=${city}&state=${opts.state}&site=${opts.office}&textField1=${lat}&textField2=${lon}&e=0`;
}
